import styled, { css } from 'styled-components';

import { Accordion } from '@/components/Accordion';
import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Grid } from '@/components/Grid';
import { LegacyButton as BaseButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';
export const StyledContainer = styled(Container)`
  margin-top: ${theme.spacing(4)};
`;
export const CategoriesTitle = styled(Typography)`
  text-align: center;
  font-family: ${theme.fontFamilies.italianPlate};
  font-size: ${theme.fontSizes.h4};
  color: ${theme.colors.almostBlack};
  margin-bottom: ${theme.spacing(2.25)};
  text-transform: uppercase;
  font-weight: 600;
`;
export const CategoriesTitleDesktop = styled(Typography)`
  padding-top: ${theme.spacing(3)};
  padding-left: ${theme.spacing(1.3)};
  text-align: left;
  font-family: ${theme.fontFamilies.italianPlate};
  font-size: ${theme.fontSizes.h4};
  color: ${theme.colors.almostBlack};
  margin-bottom: ${theme.spacing(2)};
  text-transform: uppercase;
  font-weight: 600;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding-left: ${theme.spacing(3)};
    }
  `}
`;
export const LinksWrapperMobile = styled(Box)`
  ${({ theme }) => css`
    margin: 0 auto;
    margin-bottom: ${theme.spacing(4)};
    max-width: 100%;
    margin-left: ${({ theme }) => theme.spacing(0)};
    margin-right: ${({ theme }) => theme.spacing(0)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${theme.media.md.up} {
      display: none;
    }
  `}
`;
export const LinksWrapperDesktop = styled(Box)<{
  $linksWrapperDesktopTop: number;
  $isHeaderBelowFaqsTop: boolean;
  $isHeaderBottomWithinLinks: boolean;
}>`
  ${({
    theme,
    $linksWrapperDesktopTop,
    $isHeaderBelowFaqsTop,
    $isHeaderBottomWithinLinks,
  }) => css`
    display: none;
    ${theme.media.md.up} {
      position: ${$isHeaderBelowFaqsTop && !$isHeaderBottomWithinLinks
        ? 'fixed'
        : 'static'};
      top: ${$isHeaderBelowFaqsTop && !$isHeaderBottomWithinLinks
        ? $linksWrapperDesktopTop + 'px'
        : 'unset'};
      background-color: ${theme.colors.secondaryLightGrey};
      width: 376px;
      margin-right: ${theme.spacing(2)};
      margin-left: ${theme.spacing(0)};
      display: block;
    }
  `}
`;
export const LinksWrapperContainer = styled(Box)<{
  $isHeaderBottomWithinLinks: boolean;
}>`
  display: block;
  ${({ theme, $isHeaderBottomWithinLinks }) => css`
    ${theme.media.md.up} {
      display: ${$isHeaderBottomWithinLinks ? 'flex' : 'unset'};
      flex-direction: ${$isHeaderBottomWithinLinks ? 'column' : 'unset'};
      justify-content: ${$isHeaderBottomWithinLinks ? 'flex-end' : 'unset'};
    }
  `}
`;
export const StyledAccordion = styled(Accordion)<{ $isOpen: boolean }>`
  margin-top:${theme.spacing(0)};
  > header > button {
    min-height: 48px;
    height: auto;
    padding: ${theme.spacing(1.25, 2)};
  }
  > header > button > p {
    font-weight: ${theme.fontWeights.bold}
    text-align: left;
    margin-top:${theme.spacing(0.5)};
  }
  > header > button > svg {
    margin-top:${theme.spacing(0.25)};
    color: ${({ $isOpen }) =>
      $isOpen ? theme.colors.goldenRod : theme.colors.primaryDark};
  }
`;
export const LinkButtonWrapper = styled(Box)`
  ${({ theme }) => css`
    padding-left: ${theme.spacing(2)};
    ${theme.media.md.up} {
      padding-left: ${theme.spacing(3)};
    }
  `}
`;
export const LinkButton = styled(BaseButton)<{
  $hasUnderline?: Maybe<boolean>;
  $isAllTheQuestions?: Maybe<boolean>;
}>`
  text-decoration: ${({ $hasUnderline }) =>
    $hasUnderline ? 'underline' : 'none'};
  text-underline-offset: ${theme.spacing(0.25)};
  font-size: ${theme.fontSizes.h5};
  font-family: ${theme.fontFamilies.italianPlate};
  font-weight: ${({ $isAllTheQuestions }) =>
    $isAllTheQuestions ? '600' : '500'};
  line-height: 40px;
  height: 40px;
  color: ${theme.colors.primaryDark};
  &:hover {
    color: ${theme.colors.primaryDark};
  }
  &:focus {
    color: ${theme.colors.primaryDark};
  }
`;
export const FaqWrapListWrapper = styled(Box)`
  ${({ theme }) => css`
    & > div:last-child {
      margin-bottom: ${theme.spacing(5)};
    }
    ${theme.media.md.up} {
      & > div:last-child {
        margin-bottom: ${theme.spacing(0)};
      }
    }
  `}
`;

export const StyledGrid = styled(Grid)`
  ${({ theme }) => css`
    display: block;
    margin-bottom: unset;
    ${theme.media.md.up} {
      display: grid;
      grid-template-columns: minmax(260px, 392px) 1fr;
      gap: ${theme.spacing(2)};
      margin-bottom: ${theme.spacing(5)};
    }
  `}
`;
